export default __webpack_public_path__ + "static/media/IMG_3538.fa58c28c.jpg";